import { useBrowser } from "../../../contexts/BrowserContext"
import useWorkspace from "../workspace/useWorkspace"
import { useDomainVerifier } from "./useDomainVerifier"

export const useActiveWorkspacePage = () => {
  const { tabInfo } = useBrowser()
  const { workspace } = useWorkspace()
  const domainVerifier = useDomainVerifier(workspace?.hostnames)
  const isVerifiedWorkspacePage = Boolean(
    tabInfo.isSupportedPage
    && tabInfo.tabUrl
    && domainVerifier.isVerified(tabInfo.tabUrl)
  )

  return {
    ...tabInfo,
    isVerifiedWorkspacePage,
  }
}
